import React from 'react';
import { Helmet } from 'react-helmet';
import { useFeatureFlags } from '../../context';
const getTitle = (title) => {
    const websiteName = 'Dashboard';
    if (title) {
        return `${title} - ${websiteName}`;
    }
    return websiteName;
};
/**
 * @deprecated titles are now set by the IA config
 */
export const PageTitle = ({ title }) => {
    const { getFeatureFlag } = useFeatureFlags();
    const isNewHeaderEnabled = getFeatureFlag('tempDashboardIaHeadings251024');
    if (isNewHeaderEnabled) {
        return null;
    }
    return (React.createElement(Helmet, null,
        React.createElement("title", { "data-testid": "pagetitle" }, getTitle(title))));
};
